/**
 * Service tiers and the client pages each one leaves out.
 *
 * Reporting only is the attribution-only plan Shawn described on 2026-09-25:
 * the agency connects tracking and the client gets reporting, with no delivery
 * work, so content, creative and project pages are left out of the client's
 * sidebar and show a plan notice if opened directly. Every other tier keeps
 * every page. No imports and only erasable types, so node --test loads this
 * file directly (test/tiers.test.js).
 */
export const SERVICE_TIERS = ["reporting_only", "ai_only", "standard", "fractional_cmo"];

const LABELS: Record<string, string> = {
  reporting_only: "Reporting only",
  ai_only: "AI only",
  standard: "Standard",
  fractional_cmo: "Fractional CMO",
};

/** The name a person reads for a tier; an unknown value is shown as stored. */
export function tierLabel(tier: string | null | undefined): string {
  const t = tier || "standard";
  return LABELS[t] || t;
}

/** Client pages a tier does not include. */
export const DELIVERY_PATHS = ["/content-ideas", "/viral", "/content", "/creative", "/projects"];
const LEFT_OUT: Record<string, string[]> = { reporting_only: DELIVERY_PATHS };

export function tierLeavesOut(tier: string | null | undefined, path: string): boolean {
  return (LEFT_OUT[tier || ""] || []).includes(path);
}
